import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const RequestedBy = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allOptionList, setAllOptionList] = useState([]);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allOptionList);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.COSTING_LIST]: dependentFilterList?.requestedByList,
		[allFilterPages.SAMPLE_LIST]: dependentFilterList?.requestByList
	};

	const onFetchData = () => {
		let responseData = filterData[filterPageName];
		responseData = responseData?.map((item) => {
			return { id: item.id, name: item.name, count: item?.count };
		});

		setAllOptionList(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allOptionList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: allOptionList;
		setData(searchResult);
	};

	return (
		<>
			<FilterName type="REQUESTED_BY" />
			<Checkbox type="REQUESTED_BY" data={data} handleSearch={handleSearch} />
		</>
	);
};

export default RequestedBy;
